import { useStoreState } from "lib/store"

export function useSkills() {
    return useStoreState("skills", {})
}

export function useSkill(skillCode) {
    return useSkills()?.[0]?.[skillCode]
}
